<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-md-10 featured-box">
                    <div>
                        <div class="pb-4 mobilepb-0">
                            <div class="tab-content" >
                                <div class="tab-pane fade show active" id="home-tab" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                                    <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" width="100%" height="100%" scrolling="auto" style="border: none;min-height: 600px !important;"  [src]="graphicTvUrl"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>